import gql from 'graphql-tag';
const verifyChef = gql`mutation verifyChef($cardId: String!) {
    verifyChef(cardId:$cardId)
}`
export default verifyChef;
